import { ResponsiveSize } from '../models/index';
import { UseCase } from './UseCase';

export namespace GetResponsiveValue {
    export interface Params<T> {
        options: { [Size in ResponsiveSize]?: T };
        size: ResponsiveSize;
    }
}

export class GetResponsiveValue
    implements UseCase<GetResponsiveValue.Params<any>, any | undefined>
{
    execute<T>({ options, size }: GetResponsiveValue.Params<T>): T | undefined {
        return options && (options[size] || options.desktop || options.tablet || options.handset);
    }
}
